<div class="documents-dialog" *ngIf="active">
  <div class="documents-dialog__content">
    <button class="documents-dialog__content__close" (click)="closeDialog()">
      <span class="material-icons">close</span>Close
    </button>
    <h2>Submit All Bids?</h2>

    <ng-container>
      <div class="">
        <div class="mb-10">
          {{
            "Clicking “Submit All Bids” will send " +
              numberOfBids +
              " project(s) for review."
          }}
          <br /><br />
          Do you wish to continue?
        </div>
        <requirements-acknowledgement
          #reqAck
          [projectRequirements]="data.specialQuoteRequirements"
          [showSite]="false"
          [hasSiteRequirements]="hasAnySiteRequirements">
        </requirements-acknowledgement>
        <br />
        <div class="container mt-30">
          <div class="column column-left">
            <div class="documents-dialog__content__footer__service-type">
              <p class="documents-dialog__content__footer__service-type__label">
                Project
              </p>
              <p class="service-type">
                {{
                    "Project ID: " +
                    data.projectOrderId
                }}
              </p>
            </div>
          </div>
          <div class="right-columns panelfields">
            <div class="column">
              <button
                type="submit"
                class="btn btn-primary"
                (click)="submit()"
                [disabled]="isSubmitting || (reqAck.requiresAcknowledgement && !reqAck.acknowledged)">
                Submit All Bids
              </button>
            </div>
            <div class="column">
              <button
                type="submit"
                class="btn btn-default"
                (click)="closeDialog()"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="documents-dialog__background" (click)="closeDialog()"></div>
</div>
